import React from 'react'
import ImgUploader from '../../../baseApp/shared/components/fileUploader/ImgUploader';

const FloorSubForm = ({
    image,
    viewMode,
    style,
    handleImageUploaded,
    handleWrongImageFormat
}) => {
    return <div id="open-spaces-sub-form" className="field-row">
        <ImgUploader
            image={image}
            viewMode={viewMode}
            labelStyle={style}
            handleImageUploaded={handleImageUploaded}
            handleWrongImageFormat={handleWrongImageFormat}
        />
    </div>
};

export default FloorSubForm;